import React from "react";
import "../logo.css";
interface LogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const Logo = ({
  size = "md",
  className = "",
}: LogoProps): React.JSX.Element => {
  return (
    <img
      src="/logo.png"
      alt="Fiji Planner ERP Logo"
      className={`app-logo logo-${size} ${className}`}
    />
  );
};

export default Logo;
